import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";

import { GET } from "../../api/requests";
import { useVirtualizer } from "@tanstack/react-virtual";
import Button from "../../components/Button";
import WorkflowItem from "./WorkflowItem";

export default function Workflows() {
  const navigate = useNavigate();
  const parentRef = useRef();

  // fetch the workflow definitions
  const { data: workflows } = useQuery(["workflows"], async () => {
    const response = await GET(`/workflows`);
    return response;
  });

  // virtualize the list of workflows
  const rowVirtualizer = useVirtualizer({
    count: workflows?.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 100,
    overscan: 5,
  });

  return (
    <div
      className="h-full w-full xl:w-4/5 mx-auto overflow-auto"
      ref={parentRef}
    >
      <>
        {/* create new workflow button */}
        <div className="pb-8 flex justify-center">
          <Button
            label="Create new workflow"
            onClick={() => navigate("/workflows/manage")}
            className="bg-gray-800 text-white rounded-lg px-4 py-2"
          />
        </div>
        <div
          style={{
            height: `${rowVirtualizer.getTotalSize()}px`,
            width: "100%",
            position: "relative",
          }}
        >
          {rowVirtualizer.getVirtualItems().map((virtualItem) => (
            <div
              key={virtualItem.key}
              data-index={virtualItem.index}
              ref={rowVirtualizer.measureElement}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                transform: `translateY(${virtualItem.start}px)`,
              }}
            >
              <div className="mb-4">
                <WorkflowItem workflow={workflows[virtualItem.index]} />
              </div>
            </div>
          ))}
        </div>
      </>
    </div>
  );
}
